import React, { useState } from "react";
import { Avatar, Descriptions } from "antd";
import { useSelector } from "react-redux";
import { formatImgPath } from "../../../utils";

const MyAccount = ({ setIsEdit }) => {
  const { orgDetails } = useSelector((state) => state.fetch); 
  const items = [
    {
      key: "1",
      label: "Name",
      children: orgDetails?.orgName ?? "N/A",
    },
    {
      key: "2",
      label: "Business Reg No",
      children: orgDetails?.orgRegNo ?? "N/A",
    },
   
    {
      key: "4",
      label: "Company email",
      children: orgDetails?.orgEmail ?? "N/A",
    },
    {
      key: "5",
      label: "Company phone",
      children: orgDetails?.orgTelephone ?? "N/A",
    },
    {
      key: "6",
      label: "Business Type",
      children: orgDetails?.orgBizTypeName ?? "N/A",
    },
    {
      key: "6",
      label: "Business Status",
      children: orgDetails?.orgStatus ?? "N/A",
    },
    {
      key: "7",
      label: "Organization Code",
      children: orgDetails?.orgCode ?? "N/A",
    },
    {
      key: "8",
      label: "Industry",
      children: orgDetails?.orgBusinessIndustryName ?? "N/A",
    },
   
  ];
 
  const items1 = [
     {
      key: "8",
      label: "Country",
      children: orgDetails?.orgCountry ?? "N/A",
    },
    {
      key: "9",
      label: "City",
      children: orgDetails?.orgCity ?? "N/A",
    },
    {
      key: "1",
      label: "Address Type",
      children: orgDetails?.orgAddressType ?? "N/A",
    },
    {
      key: "2",
      label: "Line 1",
      children: orgDetails?.orgLine1 ?? "N/A",
    },
    {
      key: "3",
      label: "Line 2",
      children: orgDetails?.orgLine2 ?? "N/A",
    },
    {
      key: "4",
      label: "Line 3",
      children: orgDetails?.orgLine3 ?? "N/A",
    },
    {
      key: "5",
      label: "Postal Code",
      children: orgDetails?.orgPostalAddress ?? "N/A",
    },
    {
      key: "6",
      label: "State",
      children: orgDetails?.orgState ?? "N/A",
    },
  ];

  return (
    <div className="flex flex-col h-screen  w-[100%] lg:px-10 px-3">
      <div className="relative flex flex-row bg-[#EDF3FB] justify-end items-center h-[15%] w-full mt-10">
        <div className="w-[200px] mr-10">
          <button onClick={() => setIsEdit(true)} className="cstm-btn-2">
            Edit profile
          </button>
        </div>
        <div className="absolute left-[5%] rounded-full bg-white top-[50%]">
          <Avatar
            size={150}
            src={formatImgPath(
              orgDetails?.orgProfilePic == null
                ? "avatar.png"
                : orgDetails?.orgProfilePic
            )}
          />
        </div>
      </div>

      <div className="flex flex-row mt-36">
        <div className="flex lg:flex-row flex-col gap-y-10">
          <Descriptions
            column={1}
            colon={false}
            title="Company Information"
            items={items}
          />
          <Descriptions
            column={1}
            colon={false}
            title="Address Information"
            items={items1}
          />
        </div>
      </div>
    </div>
  );
};
export default MyAccount;
